import {
  Box,
  Typography,
  Avatar,
  Tooltip,
  Chip,
  Modal,
  IconButton,
  Button,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import AxiosInstance from "../../Config/AxiosInstance";
import { ApiList } from "../../Config/ApiList";
import TableContainer from "../../Components/TableContainer";
import DummyUser from "../../Assets/User.webp";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { toast } from "react-toastify";

const StrikeManagement = () => {
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(15);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [strikeData, setStrikeData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [selectedMedia, setSelectedMedia] = useState("");
  const [openApproveModal, setOpenApproveModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [openRejectModal, setOpenRejectModal] = useState(false);
  const [adminNotes, setAdminNotes] = useState("");

  const getStrikeList = async () => {
    setLoading(true);
    try {
      const params = {
        count: page * limit,
        limit: limit,
      };
      const response = await AxiosInstance.get(ApiList.GET_STRIKE, params);
      if (response && response?.data?.s) {
        const formattedReports = response?.data?.r?.map((report, index) => ({
          rowid: index + 1 + page * limit,
          ...report,
        }));
        setStrikeData(formattedReports);
        page === 0 && setTotal(response?.data?.c || 0);
      } else {
        setStrikeData([]);
      }
      setLoading(false);
    } catch (error) {
      setStrikeData([]);
      setTotal(0);
      setLoading(false);
    }
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };
  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedMedia("");
  };

  const handleStatusUpdate = async (id, newStatus, streak_count = 0, admin_notes = "") => {
    try {
      const formData = new FormData();
      formData.append("request_id", id);
      formData.append("status", newStatus);
      if (newStatus === 3) {
        formData.append("admin_notes", admin_notes);
      }
      const response = await AxiosInstance.post(
        ApiList.APPROVE_REJECT_STRIKE,
        formData
      );
      if (response && response?.data?.s) {
        toast.success(response?.data?.m || "Status updated successfully");
        getStrikeList();
      } else {
        toast.error(response?.data?.m || "Failed to update status");
      }
    } catch (error) {
      console.error("Error updating status:", error);
    }
  };

  const handleApprove = (id) => {
    setSelectedId(id);
    setOpenApproveModal(true);
  };

  const handleApproveConfirm = () => {
    handleStatusUpdate(selectedId, 1, 0);
    setOpenApproveModal(false);
    setSelectedId(null);
  };

  const handleReject = (id) => {
    setSelectedId(id);
    setOpenRejectModal(true);
  };

  const handleRejectSubmit = () => {
    handleStatusUpdate(selectedId, 3, 0, adminNotes);
    setOpenRejectModal(false);
    setAdminNotes("");
    setSelectedId(null);
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  useEffect(() => {
    getStrikeList();
  }, [page]);

  const columns = [
    {
      field: "rowid",
      headerName: "Sr.No",
      width: 80,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      minWidth: 150,
      headerClassName: "leftAlignHeader",
      cellClassName: "leftAlign",
      renderCell: (params) => {
        const name = params?.row?.name;
        const truncatedName =
          name?.length > 20 ? `${name.substring(0, 20)}...` : name;
        return <Tooltip title={name}>{truncatedName}</Tooltip>;
      },
    },
    {
      field: "email",
      headerName: "Email",
      flex: 1,
      minWidth: 200,
      headerClassName: "leftAlignHeader",
      cellClassName: "leftAlign",
      renderCell: (params) => {
        const email = params?.row?.email;
        const truncatedEmail =
          email?.length > 30 ? `${email.substring(0, 30)}...` : email;
        return <Tooltip title={email}>{truncatedEmail}</Tooltip>;
      },
    },
    // {
    //   field: "requested_streak",
    //   headerName: "Requested Streak",
    //   width: 140,
    //   align: "center",
    //   headerAlign: "center",
    // },
    // {
    //   field: "assigned_streak",
    //   headerName: "Assigned Streak",
    //   width: 140,
    //   align: "center",
    //   headerAlign: "center",
    // },
    // {
    //   field: "description",
    //   headerName: "Description",
    //   flex: 1,
    //   minWidth: 200,
    //   headerClassName: "leftAlignHeader",
    //   cellClassName: "leftAlign",
    //   renderCell: (params) => {
    //     const description = params?.row?.description;
    //     const truncatedDesc =
    //       description?.length > 30
    //         ? `${description.substring(0, 30)}...`
    //         : description;
    //     return <Tooltip title={description}>{truncatedDesc}</Tooltip>;
    //   },
    // },
    {
      field: "status",
      headerName: "Status",
      width: 180,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        const status = params?.row?.status;

        if (status === 2) {
          return (
            <Box sx={{ display: "flex", gap: 1 }}>
              <IconButton
                size="small"
                sx={{
                  color: "green",
                  border: "1px solid green",
                  borderRadius: "4px",
                  "&:hover": { backgroundColor: "rgba(0, 128, 0, 0.1)" },
                }}
                onClick={() => handleApprove(params.row.id)}
              >
                <CheckIcon fontSize="small" />
              </IconButton>
              <IconButton
                size="small"
                sx={{
                  color: "red",
                  border: "1px solid red",
                  borderRadius: "4px",
                  "&:hover": { backgroundColor: "rgba(255, 0, 0, 0.1)" },
                }}
                onClick={() => handleReject(params.row.id)}
              >
                <CloseRoundedIcon fontSize="small" />
              </IconButton>
            </Box>
          );
        }

        const statusMap = {
          1: "Approved",
          3: "Rejected",
        };

        return (
          <Chip
            label={statusMap[status] || "Unknown"}
            color={status === 1 ? "success" : "error"}
            variant="outlined"
          />
        );
      },
    },
    {
      field: "created_at",
      headerName: "Request Date",
      width: 150,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <Typography sx={{ fontSize: "12px" }}>
          {formatDate(params?.row?.created_at)}
        </Typography>
      ),
    },
  ];

  return (
    <>
      <Box
        sx={{
          width: "100%",
          height: "100vh",
          background: "#B9CC0310",
          overflow: "hidden",
        }}
      >
        <Box sx={{ width: "100%", p: 2, background: "#B9CC0310" }}>
          <Typography
            sx={{
              fontSize: { xs: "18px", md: "28px" },
              fontWeight: "300",
              color: "#000",
            }}
          >
            Streak Management
          </Typography>
        </Box>
        <Box sx={{ width: "100%", height: "calc(100vh - 74px)" }}>
          <Box
            sx={{
              width: "100%",
              height: "100%",
              p: 1,
              overflow: "scroll",
            }}
          >
            <TableContainer
              columns={columns}
              rows={strikeData}
              handlePageChange={handlePageChange}
              page={page}
              loading={loading}
              totalData={total}
              pageSize={limit}
            />
          </Box>
        </Box>
      </Box>

      {/* Reject Modal */}
      <Modal
        open={openRejectModal}
        onClose={() => setOpenRejectModal(false)}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            background: "#fff",
            color: "white",
            p: 3,
            borderRadius: 2,
            minWidth: 300,
          }}
        >
          <Typography variant="h6" mb={2} sx={{ color: "#000" }}>
            Reject Streak Request
          </Typography>
          <TextField
            fullWidth
            label="Admin Notes"
            multiline
            rows={4}
            value={adminNotes}
            onChange={(e) => setAdminNotes(e.target.value)}
            sx={{
              mb: 2,
              "& .MuiOutlinedInput-root": {
                color: "#000",
                "& fieldset": { borderColor: "#000" },
                "&:hover fieldset": { borderColor: "#000" },
                "&.Mui-focused fieldset": { borderColor: "#000" },
              },
              "& .MuiInputLabel-root": { color: "#000" },
              "& .MuiInputLabel-root.Mui-focused": { color: "#000" },
            }}
          />
          <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
            <Button 
              onClick={() => setOpenRejectModal(false)}
              sx={{ color: "#000" }}
            >
              Cancel
            </Button>
            <Button 
              variant="contained" 
              onClick={handleRejectSubmit}
              sx={{
                background: "#c6ff00",
                color: "black",
                fontWeight: "600",
                "&:hover": {
                  background: "#b5ee00",
                },
              }}
            >
              Submit
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* Approve Confirmation Modal */}
      <Modal
        open={openApproveModal}
        onClose={() => setOpenApproveModal(false)}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={{
            background: "#fff",
            color: "white",
            p: 3,
            borderRadius: 2,
            minWidth: 300,
          }}
        >
          <Typography variant="h6" mb={2} sx={{ color: "#000" }}>
            Confirm Approval
          </Typography>
          <Typography sx={{ color: "#000", mb: 3 }}>
            Are you sure you want to approve this strike request?
          </Typography>
          <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
            <Button
              onClick={() => setOpenApproveModal(false)}
              sx={{ color: "#000" }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleApproveConfirm}
              sx={{
                background: "#c6ff00",
                color: "black",
                fontWeight: "600",
                "&:hover": {
                  background: "#b5ee00",
                },
              }}
            >
              Yes, Approve
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* Modal for Media */}
      <Modal
        open={openModal}
        onClose={handleCloseModal}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        BackdropProps={{
          sx: {
            backdropFilter: "blur(5px)",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          },
        }}
      >
        <Box
          sx={{
            position: "relative",
            width: "400px",
            height: "400px",
            bgcolor: "none",
            p: 2,
            borderRadius: 2,
            outline: "none",
          }}
        >
          <IconButton
            onClick={handleCloseModal}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
            }}
          >
            <CloseIcon sx={{ color: "white" }} />
          </IconButton>
          <img
            src={selectedMedia}
            alt="Media Preview"
            style={{
              width: "100%",
              height: "100%",
              borderRadius: "8px",
              objectFit: "contain",
            }}
          />
        </Box>
      </Modal>
    </>
  );
};

export default StrikeManagement;
